module.exports = __webpack_public_path__ + "resources/img/ic-australia.d5fc21d9.png";